export default __webpack_public_path__ + "static/media/Path1669-Yono@2x.6181c334.png";